import { IOnInit, IPromise } from "angular";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { StateService } from "@uirouter/angularjs";
import { RecordFileTemplateOptions } from "../../../../../../records/forms/formly/types";
import { MachineSycuan } from "../../../../models/machine";
import { IFieldArray } from "AngularFormly";

export class SingleMachineDecommissionComponentController implements IOnInit {
  static $inject = [FormViewServiceName, "$state"];
  readonly formFields: IFieldArray;
  model: any;
  /* start bindings */
  readonly machine!: MachineSycuan;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService
  ) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
          }),
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      Files: currentConfiguration?.Files?.map((f: any) => {
        return { Name: f.Name, ContentType: f.ContentType, Url: f.Url };
      }),
    };
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const machineId = this.machine.Id;
    return this.formViewService
      .submitForm({
        url: `/api/machines/${machineId}/decommission`,
        formObject: this.model,
        formViewController,
        method: "post",
      })
      .then(() => {
        return this.$state.go("^", undefined, { reload: true });
      })
      .then(() => {});
  }

  cancel(): Promise<void> {
    return this.$state.go("^").then(() => {});
  }
}
